import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import * as awsui from "@cloudscape-design/design-tokens";
import FRG_Rules from "../../frg-rules";

interface rulesHrefObj { [key: string]: string }


export default function Rules() {
  const { 
    activeSeriesName, setActiveSeriesName,
    activeSeriesRef, setActiveSeriesRef,
  } = useContext(GlobalContext);


  const Rules = () => {
    return (
      <></>
    )
  }


  return (
    <center>
      <div style={{ width: "100%" }}>
        <div data-rules className="body-content" style={{ maxWidth: "1200px", textAlign: "left" }}> 
        <Tabs
          tabs={[
            {
              label: "FRG League Rules",
              id: "frgRules",
              content: <FRG_Rules />
            },
            // {
            //   label: "Series Rules",
            //   id: "seriesRules",
            //   content: <Rules />
            // }
          ]}
        />          
        </div>
      </div>
    </center>
  );
}

